import loadMore from '../cpt-listing/ajax';

const cptFilters = {

    init() {
        const filters = document.querySelectorAll('.cpt-filters');
        if ( !filters ) return;

        filters.forEach(filterContainer => {
            const filterButtons = filterContainer.querySelectorAll('.js-wp-element-button-filter');

            cptFilters.filterByTerms(filterButtons);

            const searchForm = filterContainer.querySelector('form');

            cptFilters.searchItems(searchForm);

        });

    },

    searchItems( searchForm ) {

        const searchInput = searchForm.querySelector('input');
        if ( !searchInput ) return;
        searchInput.removeAttribute('required');

        searchForm.addEventListener('submit', (e) => {
            e.preventDefault();

            const button =  loadMore.settings.button;
            const postListing = button.closest('.post-listing');
            const postListingContainer = postListing.querySelector('.post-listing__posts');
            button.dataset.searchFor = searchInput.value;

            loadMore.getDataFromButton(button);

            postListingContainer.innerHTML = '';

            loadMore.loadMorePosts(button, postListingContainer, true);

        });
    },

    filterByTerms( filters ) {

        if ( ! filters.length ) return;

        filters.forEach(filter => {
            filter.addEventListener('click', (e) => {
                e.preventDefault();

                filter.parentNode.classList.add('is-active');
                filters.forEach(filterItem => {
                    if ( filterItem !== e.currentTarget ) {
                        filterItem.parentNode.classList.remove('is-active');
                    }
                })

                const filterTermSlug = filter.dataset.termSlug;
                const filterTermTaxonomy = filter.dataset.termTaxonomy;


                const button =  loadMore.settings.button;
                const postListing = button.closest('.post-listing');
                const postListingContainer = postListing.querySelector('.post-listing__posts');
                button.dataset.taxonomy = filterTermTaxonomy;
                button.dataset.taxonomyTerm = filterTermSlug;
                loadMore.getDataFromButton(button);

                postListingContainer.innerHTML = '';

                loadMore.loadMorePosts(button, postListingContainer, true);

            });
        });
    },

    queryListingContainer() {
        const button = document.querySelector('.js-load-more');
        const postListing = button.closest('.post-listing');
        const postListingContainer = postListing.querySelector('.post-listing__posts');
        postListingContainer.innerHTML = '';

        loadMore.loadMorePosts(button, postListingContainer);
    }
}

window.addEventListener('DOMContentLoaded', () => cptFilters.init());
